<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3 class="pull-left">{{multiLanguage.detail}}&nbsp;&nbsp;({{obj.IB_ID}})</h3>
        <div class="pull-right" style="margin-top:12px;">
          <el-button
            @click="$router.go(-1)"
            class="preview-btn"
            round
            type="warning"
          >{{multiLanguage.return}}</el-button>
        </div>
        <div class="clear"></div>
      </div>
      <div class="panel" element-loading-spinner="el-icon-loading" v-loading="loading">
        <mtable
          :downLoadTran="downLoadTran"
          :jsonExcelAjax="jsonExcelAjax"
          :multiLanguage="multiLanguage"
          :name="name"
          :thData="thData"
          :trData="trData"
          v-if="trData"
        >
          <div class="handleDiv" slot="handle">
            <div class="spanDiv">
              <span>{{multiLanguage.IB_ID}}&nbsp;{{obj.IB_ID}}</span>
            </div>
            <div class="spanDiv">
              <span>{{multiLanguage.typeText}}&nbsp;{{obj.type}}</span>
            </div>
            <div class="spanDiv">
              <span>{{multiLanguage.deposit_order_id}}&nbsp;{{obj.DEPOSIT_ORDER_ID}}</span>
            </div>
            <div class="spanDiv">
              <span>{{multiLanguage.start_time}}&nbsp;{{obj.BEGINTIME}}</span>
            </div>
            <div class="spanDiv">
              <span>{{multiLanguage.end_time}}&nbsp;{{obj.ENDTIME}}</span>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from '../../comm/mytable'
import { URL_REALTIMEDETAIL } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
  name: 'realTimeDetailResult',
  mixins: [require('common/mixin/base.js').base({ multiLanguage: 'realTimeReport' }), require('common/mixin/base.js').base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data() {
    return {
      trData: [],
      obj: {},
      url: '',
      loading: true
    }
  },
  mounted() {
    this.obj = this.$route.query
    let getReqObj = {
      params: {
        report_id: this.obj.REPORT_ID,
        type: this.obj.TYPE,
        id: this.obj.IB_ID,
        beginTime: this.obj.BEGINTIME,
        endTime: this.obj.ENDTIME
      }
    };
    this.url = api.getUrl20(this.curArea, URL_REALTIMEDETAIL);
    this.getIbReportDatas(this.url, getReqObj);
  },
  methods: {
    getIbReportDatas(url, obj) {
      this.$http.get(url, obj).then(res => {
        this.trData = res.data.data
        this.setOfficeState()
        this.loading = false
      })
    },
    setOfficeState() {
      let list = this.multiLanguage.detailType
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index]
          if (this.obj.TYPE == 1) {
            let group = temp.PRODUCT_GROUP
            let rule = temp.RULE_ID
            temp.rule_id = temp.RULE_ID ? this.publicLan.rule[temp.RULE_ID] : ''
            temp.product_group = temp.PRODUCT_GROUP ? this.publicLan.products[temp.PRODUCT_GROUP] : ''
            if (index !== this.trData.length - 1) {
              temp.ib_id = temp.IB_ID
              return true
            }
            temp.ib_id = this.multiLanguage.total[temp.IB_ID]
            return true
          }
          temp.type = temp.TYPE || temp.TYPE == 0 ? list[temp.TYPE] : ''
          if (index === this.trData.length - 1) {
            temp.trade_order_id = this.multiLanguage.total[temp.TRADE_ORDER_ID]
            return true
          }
          temp.trade_order_id = temp.TRADE_ORDER_ID
        })
      }
    }
  },
  computed: {
    thData() {
      return this.multiLanguage[this.obj.TYPE == 1 ? 'lowerLevel' : 'detailTh_v2']
    },
    name() {
      return this.multiLanguage.detail
    },
    downLoadTran() {
      if (this.obj.TYPE == 1) {
        return {
          IB_ID: this.multiLanguage.total,
          RULE_ID: this.publicLan.rule,
          PRODUCT_GROUP: this.publicLan.products
        }
      }
      return {
        TRADE_ORDER_ID: this.multiLanguage.total,
        TYPE: this.multiLanguage.detailType
      }
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        rID: this.obj.IB_ID,
        type: this.multiLanguage.typeList[this.obj.TYPE],
        ajaxPar: {
          report_id: this.obj.REPORT_ID,
          type: this.obj.TYPE,
          id: this.obj.IB_ID,
          beginTime: this.obj.BEGINTIME,
          endTime: this.obj.ENDTIME
        }
      }
    }
  },
  watch: {
    multiLanguage() {
      this.obj.type = this.multiLanguage.typeList[this.obj.TYPE]
      this.changeTime = false
      this.setOfficeState()
    },
    curArea() {
      sessionStorage.removeItem('back')
      this.$router.push('realTimeResult')
    }
  },
  components: {
    mtable
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
  .preview-btn {
    border: 1px solid #f08712;
    background-color: #f08712;
    border-radius: 5px;
  }
}
.menuDiv {
  float: left;
  margin-right: 40px;
}
.handleDiv {
  float: left;
  .spanDiv {
    float: left;
    margin-right: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// realTimeDetailResult.vue?b194184a